// extracted by mini-css-extract-plugin
export var standaloneTable = "_gs-0";
export var standaloneTableWithBodyFill = "_gs-1";
export var withExtraHeader = "_gs-2";